import AccountAdminAccount from "./AccountAdminAccount-container";

/**
 * Export the top level component AccountAdminAccount-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default AccountAdminAccount;
